const mrpPurchaseSuppliers = [
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Código',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },
  {
    group: 'Recomendado',
    columns: [
      {
        name: 'Valor',
        id: 'recomendado-valor',
        show: true
      }
    ]
  },
  {
    group: 'Desejado',
    columns: [
      {
        name: 'Valor',
        id: 'desejado-valor',
        show: true
      },
      {
        name: 'Volume',
        id: 'desejado-volume',
        show: true
      },
      {
        name: 'Dif %',
        id: 'desejado-dif',
        show: true
      },
      {
        name: 'Faturamento Mínimo',
        id: 'desejado-faturamento-minimo',
        show: true
      }
    ]
  }
]

export default mrpPurchaseSuppliers
